import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { DevExtremeModule } from 'devextreme-angular';
// RECOMMENDED (doesn't work with system.js)
//import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
//import { ButtonsModule } from 'ngx-bootstrap';
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
//import { AccordionModule } from 'ngx-bootstrap/accordion';


import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { PageComponent } from './page/page.component';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { CurrentBillComponent } from './current-bill/current-bill.component';
import { PowerUsageComponent } from './power-usage/power-usage.component';
import { BillingHistoryComponent } from './billing-history/billing-history.component';
import { NavComponent } from './nav/nav.component';
//import { DropDownDirective } from './directives/drop-down.directive';
import { LogoBannerComponent } from './logo-banner/logo-banner.component';
import { PayNowComponent } from './pay-now/pay-now.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { AboutYouComponent } from './about-you/about-you.component';
import { SetPassComponent } from './set-pass/set-pass.component';
import { OptionsContainerComponent } from './options-container/options-container.component';
import { ManagePaymentsComponent } from './manage-payments/manage-payments.component';
import { WaysToPayComponent } from './ways-to-pay/ways-to-pay.component';
import { BillingComponent } from './billing/billing.component';
import { HistoryContainerComponent } from './history-container/history-container.component';
import { AlarmContainerComponent } from './alarm-container/alarm-container.component';
import { UsageContainerComponent } from './usage-container/usage-container.component';
import { ArrangementsContainerComponent } from './arrangements-container/arrangements-container.component';
import { PowerUsageService } from './power-usage.service';
import { AccountDetailsService } from './services/account-details.service';
import { CurrentBillService } from './services/current-bill.service';
import { UtilitiesService } from './utilities/utilities.service';
import { RegistrationService } from './services/registration.service';
import { LoginService } from './services/login.service';
import { WaterUsageService } from './services/water-usage.service';
import { AlarmsService } from './services/alarms-service.service';
import { BillingNavComponent } from './billing-nav/billing-nav.component';
import { AuthNavComponent } from './auth-nav/auth-nav.component';
import { StatusContainerComponent } from './status-container/status-container.component';
import { ReportOutageContainerComponent } from './report-outage-container/report-outage-container.component';
import { AlertMsgComponent } from './alert-msg/alert-msg.component';
import { ProfileContainerComponent } from './profile-container/profile-container.component';
import { ContactContainerComponent } from './contact-container/contact-container.component';
import { LoginInfoContainerComponent } from './login-info-container/login-info-container.component';
import { LettersFormsContainerComponent } from './letters-forms-container/letters-forms-container.component';
import { ManageLettersComponent } from './manage-letters/manage-letters.component';
import { ManageFormsComponent } from './manage-forms/manage-forms.component';
import { StartStopMoveComponent } from './start-stop-move/start-stop-move.component';
import { InfoMessageComponent } from './info-message/info-message.component';
import { StartServiceComponent } from './start-service/start-service.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { ContactUsContainerComponent } from './contact-us-container/contact-us-container.component';
import { FindAnswersContainerComponent } from './faqs/faqs.component';
import { ManageAccountsContainerComponent } from './manage-accounts-container/manage-accounts-container.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ForgetUsernameComponent } from './forget-username/forget-username.component';
import { AddAccountContainerComponent } from './add-account-container/add-account-container.component';
import { FlowAlertsComponent } from './flow-alerts/flow-alerts.component';
import { VacactionAlertComponent } from './vacaction-alert/vacaction-alert.component';
import { ColdWeatherAlertsComponent } from './cold-weather-alerts/cold-weather-alerts.component';
import { WaterUsageAlertsComponent } from './water-usage-alerts/water-usage-alerts.component';
import { BudgetAlertsComponent } from './budget-alerts/budget-alerts.component';


@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    HomeComponent,
    PageComponent,
    AccountDetailsComponent,
    CurrentBillComponent,
    PowerUsageComponent,
    BillingHistoryComponent,
    NavComponent,
    //DropDownDirective,
    LogoBannerComponent,
    PayNowComponent,
    LoginComponent,
    RegisterComponent,
    AboutYouComponent,
    SetPassComponent,
    OptionsContainerComponent,
    ManagePaymentsComponent,
    WaysToPayComponent,
    BillingComponent,
    HistoryContainerComponent,
    UsageContainerComponent,
    AlarmContainerComponent,
    ArrangementsContainerComponent,
    BillingNavComponent,
    AuthNavComponent,
    StatusContainerComponent,
    ReportOutageContainerComponent,
    ProfileContainerComponent,
    AlertMsgComponent,
    ContactContainerComponent,
    LoginInfoContainerComponent,
    LettersFormsContainerComponent,
    ManageLettersComponent,
    ManageFormsComponent,
    StartStopMoveComponent,
    InfoMessageComponent,
    StartServiceComponent,
    ResetPasswordComponent,
    ForgetPasswordComponent,
    ForgetUsernameComponent,
    TermsOfServiceComponent,
    ContactUsContainerComponent,
    FindAnswersContainerComponent,
    ManageAccountsContainerComponent,
    AddAccountContainerComponent,
    FlowAlertsComponent,
    VacactionAlertComponent,
    ColdWeatherAlertsComponent,
    WaterUsageAlertsComponent,
    BudgetAlertsComponent
  ],
  imports: [
    //BsDropdownModule.forRoot(),
    RecaptchaModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    //AccordionModule.forRoot(),
    RecaptchaFormsModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    DevExtremeModule,
    //ButtonsModule,



    RouterModule.forRoot([

      { path: '', redirectTo: 'Login', pathMatch: 'full' },
      { path: 'Billing', component: PageComponent },
      { path: 'Billing/Home', component: PageComponent },
      { path: 'Billing/PayBill/Setup', component: PayNowComponent },
      { path: 'Login', component: LoginComponent },
      { path: 'Login/Reset', component: ResetPasswordComponent },
      { path: 'Login/Forget', component: ForgetPasswordComponent },
      { path: 'Login/ForgetUserName', component: ForgetUsernameComponent },
      { path: 'Register', component: RegisterComponent },
      { path: "MyProfile/AddAccount", component: AddAccountContainerComponent },
      { path: 'About', component: AboutYouComponent },
      { path: 'SetPass', component: SetPassComponent },
      { path: 'Billing/BillingPaymentOptions', component: OptionsContainerComponent },
      { path: 'Billing/BillHistory', component: HistoryContainerComponent },
      { path: 'Billing/Usage', component: UsageContainerComponent },
      { path: 'Billing/PaymentArrangements', component: ArrangementsContainerComponent },
      { path: 'ServiceStatus/Overview', component: StatusContainerComponent },
      { path: 'CustService/Overview', component: PageComponent },
      { path: 'CustService/LettersForms', component: LettersFormsContainerComponent },
      { path: 'CustService/ServiceRequests', component: StartStopMoveComponent },
      { path: 'CustService/StartService/FindAddress', component: StartServiceComponent },
      { path: 'CustService/FAQs', component: FindAnswersContainerComponent },
      { path: 'CustService/Support', component: ContactUsContainerComponent },
      { path: 'MyProfile/Overview', component: ProfileContainerComponent },
      { path: 'MyProfile/Alerts', component: AlarmContainerComponent },
      { path: 'MyProfile/ContactInfo', component: ContactContainerComponent },
      { path: 'MyProfile/LoginInfo', component: LoginInfoContainerComponent },
      { path: 'MyProfile/ManageAccounts', component: ManageAccountsContainerComponent },
      { path: "TermsOfService", component: TermsOfServiceComponent },
      { path: '**', redirectTo: 'Login' }
    ])
  ],

  providers: [
    PowerUsageService,
    AccountDetailsService,
    CurrentBillService,
    RegistrationService,
    UtilitiesService,
    LoginService,
    WaterUsageService,
    AlarmsService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: '6LduUogUAAAAAGjt6DX5FvM91OCkPrtal1e71xBz' } as RecaptchaSettings,
    }
  ],
  bootstrap: [AppComponent],
  exports: [RouterModule]
})
export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts